// The desktop nav dropdown (design/artboards/Lockbox Nav Dropdown.dc.html, note 01).
//
// The panel is a <details class="dc-nav-drop"> so click, Enter and Space, and the expanded state,
// are the browser's. This adds what a <details> cannot do on its own: open on hover after a
// 120ms intent delay, close on pointer leave, Esc, a click outside, or focus leaving the panel,
// and keep one panel open at a time. Hover only where a pointer can hover; on touch the summary
// is a plain toggle.
(() => {
  const drops = [...document.querySelectorAll('.dc-page details.dc-nav-drop')];
  const canHover = window.matchMedia('(hover: hover)').matches;

  const closeOthers = (keep) => { for (const d of drops) if (d !== keep) d.open = false; };

  for (const drop of drops) {
    const summary = drop.querySelector(':scope > summary');
    let timer = null;

    if (canHover) {
      drop.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        if (drop.open) return;
        timer = setTimeout(() => { closeOthers(drop); drop.open = true; }, 120);
      });
      // A short grace on leave, so a pointer that clips the edge on its way from the label into
      // the panel does not close it; re-entering within it cancels the close.
      drop.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        timer = setTimeout(() => { drop.open = false; }, 160);
      });
    }

    drop.addEventListener('toggle', () => { if (drop.open) closeOthers(drop); });

    drop.addEventListener('focusout', (e) => {
      if (drop.open && e.relatedTarget && !drop.contains(e.relatedTarget)) drop.open = false;
    });
  }

  document.addEventListener('click', (e) => {
    for (const d of drops) if (d.open && !d.contains(e.target)) d.open = false;
  });

  // Esc closes an open panel wherever focus is (a hover-opened panel has none inside); focus
  // returns to the label only when it was in the panel, so a keyboard user is not stranded.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    for (const d of drops) {
      if (!d.open) continue;
      const inside = d.contains(document.activeElement);
      d.open = false;
      if (inside) d.querySelector(':scope > summary')?.focus();
    }
    for (const l of locales) l.close();
  });

  // Language and currency (snippets/dc-locale.liquid): a pill opens its list; choosing an entry
  // writes the hidden input and submits Shopify's localization form. Athens' <localization-form>
  // element expected markup the port never had, so these are the theme's own (2026-09-21).
  const locales = [...document.querySelectorAll('.dc-page .dc-locale')].map((box) => {
    const toggle = box.querySelector('.dc-locale-toggle');
    const list = box.querySelector('.dc-locale-list');
    const input = box.querySelector('input[name="locale_code"], input[name="country_code"]');
    const form = box.querySelector('form');
    if (!toggle || !list || !input || !form) return null;
    const set = (open) => { list.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); };
    const api = { box, close: () => set(false) };
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const open = list.hidden;
      for (const l of locales) if (l !== api) l.close();
      set(open);
    });
    list.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-value]');
      if (!a) return;
      e.preventDefault();
      input.value = a.dataset.value;
      form.submit();
    });
    return api;
  }).filter(Boolean);

  document.addEventListener('click', (e) => {
    for (const l of locales) if (!l.box.contains(e.target)) l.close();
  });

  // The mobile drawer's selects (style 'selects'): the phone's own picker chooses, the form submits.
  // The submit reloads the page, which would land with the drawer shut; Sam wants to stay in it
  // (2026-10-03). So return_to carries `#dc-menu` and the reloaded page reopens the drawer, only
  // where the mobile header shows (the desktop never has it). A fragment rather than
  // sessionStorage, because a country in another market redirects to that market's domain
  // (Germany → thelockbox.de).
  const MENU_MARK = '#dc-menu';
  for (const select of document.querySelectorAll('.dc-page .dc-locale-select')) {
    select.addEventListener('change', () => {
      const back = select.form.querySelector('input[name="return_to"]');
      if (back) back.value = back.value.split('#')[0] + MENU_MARK;
      select.form.submit();
    });
  }
  if (location.hash === MENU_MARK) {
    history.replaceState(null, '', location.pathname + location.search);
    const toggle = document.querySelector('.dc-page .dc-m-menu-toggle');
    if (toggle?.nextElementSibling?.getClientRects().length) toggle.checked = true;
  }
})();
